import Bitmap from "../../../bitmap";

/**
 * Draws a straight rectangular border
 */
export function drawStraightBorder(
  bit: Bitmap,
  x: number,
  y: number,
  width: number,
  height: number,
  color: string
): void {
  bit.drawShape([x, y, x + width, y, x + width, y + height, x, y + height], color);
}

/**
 * Draws a border with curved outer edge
 */
export function drawCurvedBorder(
  bit: Bitmap,
  x: number,
  y: number,
  width: number,
  height: number,
  side: 'left' | 'top' | 'right' | 'bottom',
  radius: number,
  color: string
): void {
  const ctx = bit.context;
  ctx.beginPath();
  ctx.fillStyle = color;
  
  const rx = Math.round(x);
  const ry = Math.round(y);
  const rw = Math.round(width);
  const rh = Math.round(height);
  const curveAmount = Math.min(radius, Math.min(rw / 2, rh / 2));
  
  if (side === 'left') {
    // Left border - only curve the outer (left) edge, keep inner edge straight
    ctx.moveTo(rx, ry);
    // Outer edge curves outward
    ctx.quadraticCurveTo(rx - curveAmount, ry + rh / 2, rx, ry + rh);
    // Bottom edge (straight)
    ctx.lineTo(rx + rw, ry + rh);
    // Inner edge (straight, right side)
    ctx.lineTo(rx + rw, ry);
    // Top edge (straight)
    ctx.lineTo(rx, ry);
  } else if (side === 'top') {
    // Top border - only curve the outer (top) edge, keep inner edge straight
    ctx.moveTo(rx, ry);
    // Outer edge curves outward
    ctx.quadraticCurveTo(rx + rw / 2, ry - curveAmount, rx + rw, ry);
    // Right edge (straight)
    ctx.lineTo(rx + rw, ry + rh);
    // Inner edge (straight, bottom side)
    ctx.lineTo(rx, ry + rh);
    // Left edge (straight)
    ctx.lineTo(rx, ry);
  } else if (side === 'right') {
    // Right border - only curve the outer (right) edge, keep inner edge straight
    ctx.moveTo(rx + rw, ry);
    // Outer edge curves outward
    ctx.quadraticCurveTo(rx + rw + curveAmount, ry + rh / 2, rx + rw, ry + rh);
    // Bottom edge (straight)
    ctx.lineTo(rx, ry + rh);
    // Inner edge (straight, left side)
    ctx.lineTo(rx, ry);
    // Top edge (straight)
    ctx.lineTo(rx + rw, ry);
  } else if (side === 'bottom') {
    // Bottom border - only curve the outer (bottom) edge, keep inner edge straight
    ctx.moveTo(rx, ry + rh);
    // Outer edge curves outward
    ctx.quadraticCurveTo(rx + rw / 2, ry + rh + curveAmount, rx + rw, ry + rh);
    // Right edge (straight)
    ctx.lineTo(rx + rw, ry);
    // Inner edge (straight, top side)
    ctx.lineTo(rx, ry);
    // Left edge (straight)
    ctx.lineTo(rx, ry + rh);
  }
  
  ctx.closePath();
  ctx.fill();
}

/**
 * Calculates border width based on block width and style
 */
export function calculateBorderWidth(width: number, style: 'default' | 'thick'): number {
  return style === 'thick' ? Math.ceil(width / 6) : Math.ceil(width / 10);
}

